<template>
  <div>
    <v-icon size="100">mdi-face-agent</v-icon>
    <div class="text-h6">
      <div>Sem jogos ativos.</div>
      <div>
        Contate o
        <a
          :href="
            `https://api.whatsapp.com/send?phone=${this.$store.state.operators.contact_phone}&text=Ol%C3%A1,%20vim%20atrav%C3%A9s%20do%20site%20e%20preciso%20de%20suporte`
          "
          >Suporte</a
        >
        para mais informações.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({}),
};
</script>
